// Place the URL here with the /api suffix.
// Ex.:`https://domain.com/api`;
const backendUrl = `https://nomasfilas.uc.r.appspot.com/api`;

/**
 * Frontend URL.
 */
const frontendUrl = {
  host: 'https://app.nomasfilas.cl',
  protocol: 'https',
};

/**
 * Tenant Mode
 * multi: Allow new users to create new tenants.
 * multi-with-subdomain: Same as multi, but enable access to the tenant via subdomain.
 * single: One tenant, the first user to register will be the admin.
 */
const tenantMode = 'multi';

/**
 * Plan payments configuration.
 */
const isPlanEnabled = false;
const stripePublishableKey = '';
const accessToken = "e6a0f6b7-fdf9-4fe5-b399-5465ba9ec9a7";

export default {
  accessToken,
  frontendUrl,
  backendUrl,
  tenantMode,
  isPlanEnabled,
  stripePublishableKey
};
